module.exports = __webpack_public_path__ + "static/media/Lam.f1c7a719.PNG";